import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlangedDummyCover = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 85,
	height: 50,
	viewBox: "0 0 85.0 50.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 65.0 0.0 L 65.0 50.0 M 85.0 0.0 L 85.0 50.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 25.0 L 55.0 25.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1,
		strokeDasharray: "2 2"
	})]
});
export default SvgFlangedDummyCover;
